export enum LayerLevel {
  REGION_SIXTEEN = 'region_sixteen',
  REGION_TEN = 'region_ten',
  REGION_SIXTEEN_CONSTITUENCY = 'region_sixteen_constituency',
  REGION_TEN_CONSTITUENCY = 'region_ten_constituency',
  CONSTITUENCY = 'constituency',
  CONSTITUENCY_POLLING_STATION = 'constituency_polling_station'
}
